import { useState } from "react";

import { Deal } from "@Types/deal";
import Button from "@Components/Button";
import SupportBubble from "@Components/SupportBubble";
import { useStickyState } from "@Hooks/useStickyState";

import ChatDialog from "./ChatDialog";
import {
  initialTicketState,
  initialLoanTicketState,
} from "../SupportMachine/TicketStateMachine";
import styles from "./TicketsChat.module.scss";

export default function TicketsChat({ deal }: { deal?: Deal }) {
  const [open, setOpen] = useState(false);
  const [state, setState] = useStickyState(
    deal ? initialLoanTicketState(deal) : initialTicketState,
    deal ? `support-chat-loan-${deal._id}` : "support-chat"
  );

  const handleOpenDialog = () => setOpen(true);
  return (
    <div className={styles.root}>
      <Button
        variant="blue"
        className={styles.button}
        onClick={handleOpenDialog}
      >
        {state.inProgress ? "Continue Submission" : "Submit New Issue"}
      </Button>
      <ChatDialog
        open={open}
        state={state}
        setOpen={setOpen}
        setState={setState}
      />
      <div className={styles.bubble} onClick={handleOpenDialog}>
        <SupportBubble />
      </div>
    </div>
  );
}
